import "./sentry";
import React from "react";
import ReactDOM from "react-dom/client";

import reportWebVitals from "./reportWebVitals";

import "bootstrap/dist/css/bootstrap.min.css";
import App from "./components/app";

import smartlookClient from "smartlook-client";
import "./index.scss";
import { Provider } from "react-redux";
import { store } from "./redux/store";
import AuthInterceptor from "./services/auth.interceptor.js";
import ErrorBoundary from "./legacy/components/ErrorBoundary";
import { smartlook } from "./config.jsx";


if (smartlook && smartlook.projectKey) {
  smartlookClient.init(smartlook.projectKey);
} 
AuthInterceptor();

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement,
);
root.render(
  
  <Provider store={store}>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </Provider>
  
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
